import xhttp from 'src/utils/xhttp'
import { formHeader } from 'src/utils/form-data'

/**
 * 设置启动页
 *
 * @param {string}  appcloud_id
 * @param {string}  platform
 * @param {string}  size
 * @param {文件}    file
 */

export const setSplash = '/api/dev/appcloud/update-start-img'

/**
 * 获取 图标及启动页
 *
 * @param {string} appcloud_id
 * @param {string} platform     [optional]
 */
export function getIconAndSplash(id) {
    return xhttp.get(`/api/dev/appcloud/img-list/${id}`)
}

/**
 * 获取 cordova config.xml
 *
 * @param {string} appcloud_id
 */
export function getCordovaConfig(id) {
    return xhttp.get(`/api/dev/appcloud/cordova/${id}`)
}

/**
 * 更新 cordova config.xml
 *
 * @param {string} appcloud_id
 * @param {string} configs      xml 内容
 */
export function setCordovaConfig(params) {
    return xhttp.put('/api/dev/appcloud/update-cordova', params)
}

/**
 * 获取 Android 证书和描述文件
 *
 * @param {string} appcloud_id
 */
export function getAndroidCred(id) {
    return xhttp.get(`/api/dev/appcloud/android-certificate/${id}`)
}

/**
 * 上传 Android 证书
 *
 * @param {string} appcloud_id
 * @param {string} store_password
 * @param {string} password
 * @param {string} alias
 * @param {文件} file
 */
export function uploadAndroidCred(params) {
    return xhttp.post('/api/dev/appcloud/upload-android-certificate', params, formHeader)
}

/**
 * 获取 iOS 证书和描述文件
 *
 * @param {string} appcloud_id
 */
export function getIosCred(id) {
    return xhttp.get(`/api/dev/appcloud/ios-certificate/${id}`)
}

/**
 * 上传 iOS 证书
 *
 * @param {string} appcloud_id
 * @param {string} password     证书密码
 * @param {string} package_type 包类型
 * @param {文件} file
 */
export function uploadIosCred(params) {
    return xhttp.post('/api/dev/appcloud/upload-certificate', params, formHeader)
}

/**
 * 上传 iOS 描述文件
 *
 * @param {string} appcloud_id
 * @param {string} package_type 包类型  [开发包 / 发布包 / 企业包]
 * @param {文件} file
 */
export function uploadIosProfile(params) {
    return xhttp.post('/api/dev/appcloud/upload-profile', params, formHeader)
}

/**
 * 获取引擎列表
 *
 * @param {string} webapp_id
 * @param {string} version_id
 * @param {string} plugin cordova-android | cordova-ios
 */
export function getEngineList(params) {
    return xhttp.get('/api/dev/plug/engine-version', { params })
}

/**
 * 设置引擎版本
 *
 * @param {string} webapp_id
 * @param {string} version_id
 * @param {string} platform android | ios
 * @param {string} version
 */
export function setEngine(params) {
    return xhttp.put('/api/dev/plug/save-engine', params)
}

/**
 * 获取 hooks
 *
 * @param {string} appcloud_id
 */
export function getHooks(id) {
    return xhttp.get(`/api/dev/appcloud/hooks-list/${id}`)
}

/**
 * 添加 hook
 *
 * @param {string} appcloud_id
 * @param {string} type         执行时机，建议为 before_prepare
 * @param {string} platform     适用平台 [ ios, android, global]
 * @param {文件} file
 */
export function addHook(params) {
    return xhttp.post('/api/dev/appcloud/hooks-add', params)
}

/**
 * 删除 hook
 *
 * @param {string} appcloud_id
 * @param {string} name     文件名
 */
export function deleteHook(params) {
    return xhttp.delete('/api/dev/appcloud/hooks-delete', { params })
}

/**
 * 下载 hook
 *
 * @param {string} appcloud_id
 * @param {string} name     文件名
 */
export function downloadHook(params) {
    return xhttp.get('/api/dev/appcloud/hooks-download', { params })
}

/**
 * 获取 plugin 安装状态
 *
 * @param {string} version_id
 */
export function getPluginStatus(id) {
    return xhttp.get(`/api/dev/plug/plugin-status/${id}`)
}

/**
 * 获取 plugin 列表
 *
 * @param {string} webapp_id
 * @param {string} version_id
 */
export function getPlugins(params) {
    return xhttp.get('/api/dev/plug/plugin-list', { params })
}

/**
 * 获取 plugin 更新日志
 *
 * @param {string} webapp_id
 * @param {string} plugin_name
 */
export function getPluginLog({ name, ...params }) {
    return xhttp.get(`/api/dev/plug/plugin-update-log/${name}`, { params })
}

/**
 * 获取 plugin 参数
 *
 * @param {string} plugin   name
 * @param {string} webapp_id
 * @param {string} version_id
 */
export function getPluginParams(params) {
    return xhttp.get('/api/dev/plug/plugin-detail', { params })
}

/**
 * 更新 plugin
 *
 * @param {string} webapp_id
 * @param {string} version_id
 * @param {string} plugin_name
 * @param {string} updateVersion
 * @param {object} plugin_param
 */
export function updatePlugin(params) {
    return xhttp.post('/api/dev/plug/update-plugin', params)
}

/**
 * 开始打包
 *
 * @param {string} version_id
 * @param {string} appcloud_id
 * @param {string} platform
 * @param {string} type         ['开发包','发布包']，platform === 'android' 时需要
 * @param {string} remark       可选
 */
export function startPackage(params) {
    return xhttp.post('/api/dev/appcloud/create-package', params)
}

/**
 * 再次打包
 *
 * @param {string} appcloud_id
 * @param {string} package_id
 */
export function rePackage(params) {
    return xhttp.post('/api/dev/appcloud/re-create-package', params)
}

/**
 * 获取打包列表
 *
 * @param {string} appcloud_id
 * @param {string} versions_id
 * @param {string} platform     可选，
 * @param {string} type         可选，['开发包','发布包']
 * @param {string} status       可选，[正在构建、构建完成、构建失败]
 * @param {string} page         可选，页码
 */
export function getPackageList(params) {
    return xhttp.get('/api/dev/appcloud/package-list', { params })
}

/**
 * 获取安装二维码
 *
 * @param {string} url
 */
export function getQrcode(url) {
    return xhttp.get(url)
}

/**
 * 上传 appstore
 *
 * @param {string} webapp_id
 * @param {string} package_id
 */
export function uploadApp(params) {
    return xhttp.post('/api/dev/appcloud/upload-appstore', params)
}
